import ProductCardList from './ProductCardList';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import withMediaQueries from '../../hocs/withMediaQueries';
import chunk from 'lodash/chunk';
import withFilteredProductItems from '../../hocs/withFilteredProductItems';

const enhance = compose(
  withFilteredProductItems,
  withMediaQueries,
  mapProps(({ items, ...props }) => ({
    ...props,
    productRow: chunk(items, props.media.tabletDown ? 2 : 3)
  }))
);

export default enhance(ProductCardList);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductCardList/index.js